import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  header: {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 'calc(112px - 40px)',
    position: 'sticky',
    top: 0,
    left: 0,
    backgroundColor: 'white',
    paddingTop: 40,
    paddingBottom: 40,
    zIndex: 99,
    [theme.breakpoints.down('sm')]: {
      background: '#F5F6FA',
      marginBottom: 0,
      display: 'flex',
      justifyContent: 'center',
      padding: '16px 8px',
      paddingTop: 24,
    },
  },
  headerSmall: {
    marginBottom: 0,
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
  },
  back: {
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.secondary.dark,
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textDecoration: 'none',
    paddingRight: 16,
    marginRight: 16,
    borderRight: `1px solid ${theme.palette.secondary.main}`,
    '&:hover': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  backIcon: {
    marginRight: 8,
    width: 24,
  },
  headerTitle: {
    [theme.breakpoints.down('sm')]: {
      color: theme.palette.primary.main,
      fontSize: '15px',
    },
  },
  headerApplicant: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      textAlign: 'left',
      display: 'block',
      color: theme.palette.primary.main,
      borderLeft: `2px solid ${theme.palette.primary.main}`,
      fontSize: '15px',
      paddingLeft: '8px',
    },
  },
}))

export default useStyles
